import { createAsyncThunk } from '@reduxjs/toolkit';
import { addYears } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';
import { ApiError } from 'shared/api';
import { ThunkAPIConfig } from 'store';

import { applyAvailability, applyAvailabilityByOldAvailabilityToken } from '../api';
import { fetchWorkCalendar } from '../api/workCalendar';
import { AvailabilityRecord, FetchWorkCalendarResponse } from '../types';

const acceptAvailabilityThunk = createAsyncThunk<AvailabilityRecord[], AvailabilityRecord[], ThunkAPIConfig>(
    'candidateAvailability/accept',
    async (payload, thunkAPI) => {
        const authToken = thunkAPI.getState().auth.accessToken;

        const response = authToken.oldAvailabilityToken
            ? await applyAvailabilityByOldAvailabilityToken(authToken.oldAvailabilityToken, payload)
            : await applyAvailability(payload);

        if (response instanceof ApiError) {
            return thunkAPI.rejectWithValue(response.errorCode);
        }

        const { availabilities } = response;

        return availabilities;
    }
);

const loadAvailabilityRequestThunk = createAsyncThunk<
    FetchWorkCalendarResponse,
    { timeZone: string },
    ThunkAPIConfig
>(
    'candidateAvailability/load',
    async ({ timeZone }, thunkAPI) => {
        const now = new Date();
        const zonedNow = toZonedTime(now, timeZone);
        const zonedToday = fromZonedTime(zonedNow, timeZone);
        const from = zonedToday;
        const to = addYears(zonedToday, 1);

        const response = await fetchWorkCalendar({
            from: from.toISOString(),
            to: to.toISOString()
        }, thunkAPI.signal);

        if (response instanceof ApiError) {
            return thunkAPI.rejectWithValue(response.errorCode);
        }

        return response;
    }
);

export {
    acceptAvailabilityThunk,
    loadAvailabilityRequestThunk
};
